import React from "react";
import { Link } from "react-router-dom"; // If using React Router
// OR use <a href="/gallery/mathematics-lab"> if not using React Router
import Breadcrumb from "../common/Breadcrumb";

const PhotoGallery = () => {
  const galleryAlbums = [
    {
      src: "/images/holi/holi-1.png",
      title: "Happy Lohri 2026",
      link: "/HappyLohri",       
    },

    {
      src: "/images/scouts/scouts-1.png",
      title: "Flag March of Scouts",
      link: "/Scouts",       
    },

    {
      src: "/images/farewell/farewell-13.png",
      title: "Farewell Function 2025-26",
      link: "/Farewell",       
    },

    {
      src: "/images/rebublic/rebublic-21.png",
      title: "77th Rebublic Day Celebration",
      link: "/RebublicDay",       
    },

    {
      src: "/images/gallery/HBP-24-1.jpg",
      title: "Happy Basant Panchami 2024",
      link: "/BasantPanchami",       
    },

    {
      src: "/images/gallery/SOF_2023-24_5.jpg",
      title: "SOF National Science Olympiad 2023-24",
      link: "/SOF",       
    },

    


    {
      src: "/images/gallery/auditorium-1.png",
      title: "Auditorium",
      link: "/Auditorium",       
    },
    
    {
      src: "/images/gallery/building-1.png",
      title: "Building",
      link: "/BuildingPhoto",
    },
    {
      src: "/images/gallery/library-1.png",
      title: "Library",
      link: "/LibraryPhoto",
    },
    
    
    {
      src: "/images/gallery/robotics-1.png",
      title: "Mathematics Lab",
      link: "/MathematicsPhoto",
    },
    {
      src: "/images/gallery/01.png",
      title: "AI & Robotics Lab Inauguration",
      link: "/AIPhoto",
    },
    {
      src: "/images/gallery/activities-1.png",
      title: "Playground Activities for Children",
      link: "/Activities",
    },

    {
      src: "/images/gallery/scout.jpg",
      title: "District Scout and Guide Rally 2022",
      link: "/DistrictScout",       
    },

    {
      src: "/images/gallery/winner.jpg",
      title: "Winners of Children's Day competition 2022",
      link: "/Winners",       
    },

    {
      src: "/images/gallery/srojni.jpg",
      title: "Sarojini Nagar Sports League 2022",
      link: "/SarojiniNagarSport",       
    },

    {
      src: "/images/gallery/hoteltaj.jpg",
      title: "Principal Conclave 2022 at Taj Hotel",
      link: "/Conclave",       
    },
    
  ];

  return (
    <>
      <Breadcrumb
        pageTitle="Gallery"
        breadcrumbItems={[
          { label: "Home", link: "/" },
          { label: "Gallery" },
        ]}
        backgroundImage="images/banner/slide-2.png"
      />

      <section className="space-ptb bg-light">
        <div className="container">
          <div className="row justify-content-center mb-5">
            <div className="col-lg-8 text-center">
              <div className="section-title">
                <h2 className="mb-3">Our Photo Gallery</h2>
                <div className="curved-line mx-auto mt-3"></div>
                {/* <p className="lead text-muted">
                  Explore our campus facilities and vibrant school life
                </p> */}
              </div>
            </div>
          </div>

          {/* Gallery Grid - Each Card Links to Its Own Page */}
          <div className="row g-4">
            {galleryAlbums.map((album, index) => (
              <div key={index} className="col-12 col-sm-6 col-lg-4 col-xl-3">
                {/* Use Link (React Router) or <a> tag */}
                <Link
                  to={album.link}
                  className="text-decoration-none"
                >
                  <div className="gallery-card h-200 rounded overflow-hidden shadow-sm hover:shadow-2xl transition-all duration-300 bg-white h-100 d-flex flex-column">
                    {/* Image */}
                    <div className="position-relative overflow-hidden flex-grow-1">
                      <img
                        src={album.src}
                        alt={album.title}
                        className="img-fluid w-100 h-100 transition-transform duration-500 hover:scale-110"
                        style={{ height: "240px", objectFit: "cover" }}
                        loading="lazy"
                      />
                      <div className="position-absolute inset-0 bg-black opacity-0 hover:opacity-40 transition-opacity duration-300"></div>
                      
                      {/* Optional: Icon or "View Gallery" on hover */}
                      <div className="position-absolute top-50 start-50 translate-middle opacity-0 hover:opacity-100 transition-all duration-300">
                        <i className="bi bi-arrow-right-circle-fill text-white fs-1"></i>
                      </div>
                    </div>

                    {/* Always Visible Title */}
                    <div className="p-4 text-center bg-white border-top">
                      <h5 className="mb-0 fw-bold text-dark">
                        {album.title}
                      </h5>
                      {/* <p className="text-primary small mb-0 mt-2">
                        View Gallery →
                      </p> */}
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default PhotoGallery;